





















































































































import { baseUrl } from "@/baseUrl";
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    valid: false,
    showError: false,
    email: "",
    emailRules: [
      (v: any) => !!v || "E-mail is required",
      (v: any) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    baseUrl: baseUrl,
    emailSend: false,
  }),

  components: {},

  methods: {
    async onResetPassword() {
      this.showError = false;
      if (this.valid) {
        this.postData().then((data) => {
          if (data) {
            this.emailSend = true;
          }
        });
      } else {
        this.showError = true;
      }
    },
    async postData() {
      try {
        const response = await fetch(`${this.$api}/v2/user/sendResetMail`, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({
            email: this.email,
          }),
        });
        return response.text();
      } catch (e) {
        console.error(e);
      }
    },
  },
});
